import * as React from 'react';
import { trackPage } from '../utils/analytics';
import type { PageCategory, PageName, PageProperties } from '../utils/analytics';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from '../types/app.types';

export type TrackPageProps = PropsFromRedux & {
  category?: PageCategory;
  name: PageName | null | undefined;
  data?: PageProperties;
};

class TrackPage extends React.Component<TrackPageProps> {
  componentDidMount() {
    const { category, name, data, dispatch } = this.props;
    dispatch(trackPage(category, name, data));
  }

  componentDidUpdate(prevProps: TrackPageProps) {
    const { category, name, data, dispatch } = this.props;
    if (prevProps.name !== this.props.name) dispatch(trackPage(category, name, data));
  }

  render() {
    return null;
  }
}

const connector = connect(null, (dispatch: Dispatch) => ({
  dispatch,
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(TrackPage);
